<template>
  <div class="container lms-wrapper-two">
    <student-nav />

    <div class="lms-content" @click="closeLevel2()">
      <student-header
        :navbarmode.sync="navbarMode"
        ref="lmsv4header"
        class="filled"
      />

      <div class="lms-content-body" style="height: calc(100vh - 80px)">
        <vue-custom-scrollbar class="" style="height: calc(100vh - 80px);">
          <div class="container-fluid mg-y-30">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb breadcrumb-style4 mg-b-10">
                <li class="breadcrumb-item">
                  <router-link
                    :to="{ name: 'buddyParticipant' }"
                    class="tx-11"
                    style="color: #444"
                    >Шинэ ажилтан</router-link
                  >
                </li>
                <li class="breadcrumb-item active tx-14" aria-current="page">
                  Checklist
                </li>
              </ol>
            </nav>
            
            <checklist :userTaskId="$store.state.user.userInfo.profileId"></checklist>
          </div>
        </vue-custom-scrollbar>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

import vueCustomScrollbar from "vue-custom-scrollbar";
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

import { getConfigValueByKey } from "@/libs/util";

//import { localSave, localRead } from "@/libs/util";

//const moment = require("moment");

import "element-ui/lib/theme-chalk/index.css";
import { Notification } from "element-ui";

export default {
  components: {
    vueCustomScrollbar,

    // userCover: () => ({
    //   component: import("@/views/modules/lms/components/userCover.vue"),
    //   loading: AsyncLoading,
    //   error: AsyncLoadError,
    //   delay: 100,
    //   timeout: 5000,
    // }),
    studentHeader: () => ({
      component: import("@/views/modules/lms/student/components/header.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    studentNav: () => ({
      component: import("@/views/modules/lms/student/components/nav.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    // studentCalendar: () => ({
    //   component: import("@/views/modules/lms/teacher/components/calendar.vue"),
    //   loading: AsyncLoading,
    //   error: AsyncLoadError,
    //   delay: 100,
    //   timeout: 5000,
    // }),
    // partUserSidebar: () => ({
    //   component: import( "@/views/modules/lms/student/parts/userSidebar.vue" ),
    //   loading: AsyncLoading,
    //   error: AsyncLoadError,
    //   delay: 100,
    //   timeout: 5000,
    // }),
    
    checklist: () => ({
      component: import(
        "@/views/modules/lms/student/buddy/components/checklist.vue"
      ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
  },
  data() {
    return {
      myResBaseUrl: "https://res.gosmart.mn/",
      navbarMode: 0,      
    };
  },
  // beforeCreate() {
  //   require('@/assets/scss/pages/learning.scss');
  // },
  created() {
    this.fetchResBase();
  },
  mounted() {
  },
  destroyed() {
    // this.toggleBodyClass("removeClass", "app-lms");
  },
  methods: {
    // logout(){
    //   this.$refs.lmsv4header.logout();
    // },
    fetchResBase() {
      if (
        this.$store.state.app.activeGroup.resBaseUrl != undefined &&
        this.$store.state.app.activeGroup.resBaseUrl != ""
      ) {
        this.myResBaseUrl = this.$store.state.app.activeGroup.resBaseUrl;
      }
    },
    ...mapActions([
      "handleAside",
      "resetResponsiveLayoutConfig",
      "handleMainLayoutConfig",
    ]),
    
    closeLevel2() {
      if (this.$store.state.app.responsiveLayout.level2.show)
        this.resetResponsiveLayoutConfig(document);
    },

    getConfigValueByKey(key) {
      return getConfigValueByKey(this.$store.state.app.groupSettings, key);
    },
  },
};
</script>
